// src/config.ts
const isDevelopment = process.env.NODE_ENV === 'development';

export const API_BASE_URL = isDevelopment 
  ? 'http://localhost:8787' 
  : 'https://api.clydes.com.br'; // <-- MUDANÇA